module.exports = __webpack_public_path__ + "static/img/xxzx.aeae88d.png";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial/xxzx.png
// module id = zKAS
// module chunks = 14